import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productsSectionHeader: {
    description: 'Collapsible section header for SKUs included in the audit',
    defaultMessage: 'SKUs in this audit',
    id: 'TDAS+g',
  },
});
